import { n as e } from "./dist-7tgynhKG.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
import * as r from "react-dom";
//#region ../../node_modules/.pnpm/@radix-ui+react-primitive@2.1.7_@types+react-dom@19.2.3_@types+react@19.2.17__@types+re_6d8fb7f79176be78f7d41dc3e06e6146/node_modules/@radix-ui/react-primitive/dist/index.mjs
var i = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((r, i) => {
	let a = e(`Primitive.${i}`), o = t.forwardRef((e, t) => {
		let { asChild: r, ...o } = e, s = r ? a : i;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ n(s, {
			...o,
			ref: t
		});
	});
	return o.displayName = `Primitive.${i}`, {
		...r,
		[i]: o
	};
}, {});
function a(e, t) {
	e && r.flushSync(() => e.dispatchEvent(t));
}
//#endregion
export { a as n, i as t };

//# sourceMappingURL=dist-B3lndwlS.js.map